import _classCallCheck from "/var/www/vhosts/zwemschoolsnorkeltje.nl/gatsby/zwemschoolsnorkeltje.nl/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/var/www/vhosts/zwemschoolsnorkeltje.nl/gatsby/zwemschoolsnorkeltje.nl/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _assertThisInitialized from "/var/www/vhosts/zwemschoolsnorkeltje.nl/gatsby/zwemschoolsnorkeltje.nl/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js";
import _inherits from "/var/www/vhosts/zwemschoolsnorkeltje.nl/gatsby/zwemschoolsnorkeltje.nl/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/var/www/vhosts/zwemschoolsnorkeltje.nl/gatsby/zwemschoolsnorkeltje.nl/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/var/www/vhosts/zwemschoolsnorkeltje.nl/gatsby/zwemschoolsnorkeltje.nl/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React from 'react'; // import { FaCheck } from "react-icons/fa";

import './Checkbox.scss';

var Checkbox = /*#__PURE__*/function (_React$Component) {
  _inherits(Checkbox, _React$Component);

  var _super = _createSuper(Checkbox);

  function Checkbox(props) {
    var _this;

    _classCallCheck(this, Checkbox);

    _this = _super.call(this, props);
    _this.state = {
      // checked: (this.props.isChecked !== null) ? this.props.isChecked : false,
      outterStyle: {
        borderColor: _this.selectColor(_this.props.color),
        width: _this.selectOutterSize(_this.props.size),
        height: _this.selectOutterSize(_this.props.size),
        borderRadius: _this.selectOutterShape(_this.props.shape)
      },
      innerStyle: {
        backgroundColor: _this.selectColor(_this.props.color),
        width: _this.selectInnerSize(_this.props.size),
        height: _this.selectInnerSize(_this.props.size),
        borderRadius: _this.selectInnerShape(_this.props.shape)
      }
    };
    _this.handleCheckboxClicked = _this.handleCheckboxClicked.bind(_assertThisInitialized(_this));
    _this.selectOutterShape = _this.selectOutterShape.bind(_assertThisInitialized(_this));
    _this.selectInnerShape = _this.selectInnerShape.bind(_assertThisInitialized(_this));
    _this.selectColor = _this.selectColor.bind(_assertThisInitialized(_this));
    _this.selectOutterSize = _this.selectOutterSize.bind(_assertThisInitialized(_this));
    _this.selectInnerSize = _this.selectInnerSize.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(Checkbox, [{
    key: "selectOutterShape",
    value: function selectOutterShape(shape) {
      switch (shape) {
        case 'square':
          return "0px";

        case 'circle':
          return "100%";

        case 'round':
          return "7px";

        default:
          return "7px";
      }
    }
  }, {
    key: "selectInnerShape",
    value: function selectInnerShape(shape) {
      switch (shape) {
        case 'square':
          return "0px";

        case 'circle':
          return "100%";

        case 'round':
          return "5px";

        default:
          return "5px";
      }
    }
  }, {
    key: "selectColor",
    value: function selectColor(color) {
      switch (color) {
        case 'red':
          return "#e03636";

        case 'blue':
          return "#4287f5";

        case 'green':
          return "#44c753";

        case 'orange':
          return "#f57e42";

        default:
          return color;
      }
    }
  }, {
    key: "selectOutterSize",
    value: function selectOutterSize(size) {
      switch (size) {
        case 'small':
          return "20px";

        case 'medium':
          return "24px";

        case 'big':
          return "28px";

        default:
          return "24px";
      }
    }
  }, {
    key: "selectInnerSize",
    value: function selectInnerSize(size) {
      switch (size) {
        case 'small':
          return "14px";

        case 'medium':
          return "18px";

        case 'big':
          return "22px";

        default:
          return "18px";
      }
    }
  }, {
    key: "handleCheckboxClicked",
    value: function handleCheckboxClicked() {
      // const {checked} = this.state
      // this.setState({
      //     checked: !checked
      // })
      this.props.onChange(!this.props.isChecked);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      return React.createElement("button", {
        className: "checkbox",
        name: this.props.name,
        onClick: function onClick(e) {
          e.preventDefault();

          _this2.handleCheckboxClicked();
        },
        style: this.state.outterStyle
      }, this.props.isChecked ? React.createElement("div", {
        className: "checkbox-selected",
        style: this.state.innerStyle
      }) : "");
    }
  }]);

  return Checkbox;
}(React.Component);

export default Checkbox;